module.exports = __webpack_public_path__ + "static/media/sociallis-logo-hor2.989cb543.png";